import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import { checkLocalSavedData, playUISound } from "../helpers/levelManager"
import { MediclinicAPI } from "../helpers/apiHandler"
import { GameAnalytics } from "gameanalytics"
export default class LoginScene extends Phaser.Scene {
	constructor() {
		super({ key: "LoginScene" })
		this.inputString = null
	}

	init() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		let scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.designWidth = scalingData.designWidth
		this.designHeight = scalingData.designHeight

		// Create a container for all UI elements to make positioning easier
		this.uiContainer = null
		this.termsContainer = null

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		//add black image to fade out
		this.black = this.add
			.image(this.safeZoneWidth / 2, this.safeZoneHeight / 2, "container")
			.setDepth(20)
			.setTint(0x000000)
		this.black.setDisplaySize(this.gameW * 5, this.gameH * 5)
		this.black.setAlpha(1)

		this.api = new MediclinicAPI()

		// Use the API tokens you were provided
		// this.api.apiTokens = {
		// 	dev: "3b19ae2b65d4822f714984a121bd3daae02f66cc6d13a75f2deae5f7806fd502e8d6c0b3aa15658a6ad4014d31ab89813ff59ec546036f8ae87e10ac8023b6795fae4a9eff97ef7b8e5fb76113e3d7a672b56ac2b3420a4455473aae208e998306bdb21904fecef0ad3863fedabc03cb959c73fd083fdd0118b709edb36e481b",
		// 	qa: "29992fd94b814a4020c883eaf3f007ced9718f40f8ae33826f1ee52bf3dbb2ed456044000c04a5189ae72450134035c878d53927ab2e9bebb8a0748e90e0e7642409f95e2286f8f061baed1885152660711c360d0c60c5c1139a4eb2b0ad295ff1965eafbe594476044c4ca2daa28698f195da5335e45d313dca4e9ecf61444c",
		// 	prod: "f01749272fd4f9ab5c64850816418789acf798c5e949e6654a046a848d74285ced6819fc7a6b115971189f00533eea7399a29cc7ce8fc46d698376bf7e5be121ac6dd53ba685d7cbaf0454030df639e82f31de5d456b32a90e1f87d074cb6daaca69eb377f937ea404241c9555d4dd5952f744df631479ef6de1f509e2b536cd",
		// }
	}

	preload() {
		this.load.plugin(
			"rexcheckboxplugin",
			"https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexcheckboxplugin.min.js",
			true,
		)
	}

	create() {
		this.soundManager = this.scene.get("GameUI").soundManager
		let backGround = this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG")
			.setScale(this.scaleFactor * 0.5)
		// Create a container for UI elements
		this.uiContainer = this.add.container(this.safeZoneX, this.safeZoneY)

		// Add the login container background
		let loginBG = this.add
			.image(
				this.safeZoneWidth / 2,
				this.safeZoneHeight / 2 + 25 * this.scaleFactor,
				"wideContainer",
			)
			.setScale(this.scaleFactor * 0.8, this.scaleFactor * 1.3)
		this.uiContainer.add(loginBG)

		// Add text elements, scaling font size based on scale factor
		let welcomeText = this.add
			.text(
				loginBG.x,
				loginBG.y - 110 * this.scaleFactor,
				"Welcome Explorer!",
				{
					fontSize: Math.round(this.fontSize + 12 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
		this.uiContainer.add(welcomeText)

		let enterIdText = this.add
			.text(
				loginBG.x,
				loginBG.y - 80 * this.scaleFactor,
				"Please Enter Your ID Number To Continue:",
				{
					fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "500",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
		this.uiContainer.add(enterIdText)

		let idTitle = this.add
			.text(
				loginBG.x - 120 * this.scaleFactor,
				loginBG.y - 30 * this.scaleFactor,
				"",
				{
					fontSize: Math.round(this.fontSize - 2 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
		this.uiContainer.add(idTitle)

		// Create Phaser placeholder for input position
		let inputPlaceholder = this.add
			.image(
				this.safeZoneWidth / 2,
				idTitle.y + 35 * this.scaleFactor,
				"button",
			)
			.setVisible(false)
		inputPlaceholder.setOrigin(0.5)
		inputPlaceholder.setScale(0.5 * this.scaleFactor)
		this.uiContainer.add(inputPlaceholder)

		// Create input field
		this.inputField = document.createElement("input")
		this.inputField.type = "tel" // Use tel instead of number for better mobile keyboard
		this.inputField.inputMode = "numeric" // Ensure numeric keyboard on supported browsers
		this.inputField.pattern = "[0-9]*" // Pattern to match only numbers
		//this.inputField.placeholder = "0000000000000"
		this.inputField.maxLength = 13
		this.inputField.style.position = "fixed"
		this.inputField.style.width = Math.round(350 * this.scaleFactor) + "px"
		this.inputField.style.height = Math.round(55 * this.scaleFactor) + "px"
		this.inputField.style.fontSize = Math.round(20 * this.scaleFactor) + "px"
		this.inputField.style.fontFamily = '"Space Grotesk", sans-serif'
		this.inputField.style.border = "2px solid black"
		this.inputField.style.background = "white"
		this.inputField.style.paddingLeft = "10px"
		this.inputField.style.color = "#11044E"
		this.inputField.style.borderRadius = "10px"
		this.inputField.style.paddingLeft = "20px"

		// Add to the HTML UI container instead of body
		const htmlContainer = document.getElementById("html-ui-container")
		htmlContainer.appendChild(this.inputField)

		// Add the CSS fix for iOS viewport shifting
		if (!document.getElementById("ios-viewport-fix")) {
			const styleElement = document.createElement("style")
			styleElement.id = "ios-viewport-fix"
			styleElement.textContent = `html, body {
			height: 100%;
			position: fixed;
			overflow: auto;
			-webkit-overflow-scrolling: touch;
			width: 100%;
		}`
			document.head.appendChild(styleElement)
		}

		// Function to update input field position
		const updateInputPosition = () => {
			let canvas = this.game.canvas
			let rect = canvas.getBoundingClientRect() // Get Phaser canvas position in window

			// Get the global position of the placeholder
			let globalPos = inputPlaceholder.getWorldTransformMatrix()
			let x = globalPos.tx
			let y = globalPos.ty

			// Position input field relative to the Phaser canvas
			this.inputField.style.left = `${rect.left + x - this.inputField.offsetWidth / 2
				}px`
			this.inputField.style.top = `${rect.top + y - this.inputField.offsetHeight / 2 - 35 * this.scaleFactor
				}px`
		}

		// Function to sync HTML container with canvas scaling
		const syncHTMLContainer = () => {
			const canvas = this.game.canvas
			const htmlContainer = document.getElementById("html-ui-container")
			const gameContainer = document.getElementById("game")

			// Get canvas and container dimensions
			const canvasRect = canvas.getBoundingClientRect()
			const containerRect = gameContainer.getBoundingClientRect()

			// Calculate the scale factor that Phaser is using
			const scaleX = canvasRect.width / this.game.config.width
			const scaleY = canvasRect.height / this.game.config.height
			const scale = Math.min(scaleX, scaleY)

			// Calculate offset for centering (letterboxing)
			const offsetX = (containerRect.width - (this.game.config.width * scale)) / 2
			const offsetY = (containerRect.height - (this.game.config.height * scale)) / 2

			// Apply the same transform to HTML container
			htmlContainer.style.transform = `scale(${scale}) translate(${offsetX / scale}px, ${offsetY / scale}px)`
			htmlContainer.style.transformOrigin = 'top left'

			// Update input position after container transform
			updateInputPosition()
		}

		// Initial sync
		syncHTMLContainer()

		// Initial position and update on resize
		updateInputPosition()

		this.inputField.addEventListener("input", () => {
			if (this.inputField.value.length >= 7) {
				agreeButton.setAlpha(1) // Set alpha to 1 when input is valid
				agreeButton.input.enabled = true // Enable the button
				agreeText.setAlpha(1) // Set alpha to 1 when input is valid
			} else {
				agreeButton.setAlpha(0.5) // Set alpha to 0.5 when input is invalid
				agreeButton.input.enabled = false // Disable the button
				agreeText.setAlpha(0.5) // Set alpha to 0.5 when input is invalid
			}
			if (this.inputField.value.length > 13) {
				this.inputField.value = this.inputField.value.slice(0, 13)
			}
			this.inputString = this.inputField.value
		})

		document.addEventListener("touchstart", (event) => {
			if (!this.inputField.contains(event.target)) {
				this.inputField.blur()
			}
		})

		let acceptText = this.add
			.text(
				this.safeZoneWidth / 2 - 40 * this.scaleFactor,
				loginBG.y + 30 * this.scaleFactor,
				"I accept the ",
				{
					fontSize: Math.round(this.fontSize - 6 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "400",
					resolution: 2,
				},
			)
			.setOrigin(1, 0.5)
		this.uiContainer.add(acceptText)

		// "terms and conditions" part in blue
		let termsText = this.add
			.text(acceptText.x, acceptText.y, "terms and conditions", {
				fontSize: Math.round(this.fontSize - 6 * this.scaleFactor) + "px",
				fill: "#5C58EB",
				fontFamily: '"Space Grotesk", sans-serif',
				fontWeight: "400",
				textDecoration: "underline",
				resolution: 2,
			})
			.setOrigin(0, 0.5)
		this.uiContainer.add(termsText)

		// Add an underline as a separate graphics object
		let underline = this.add.graphics()
		underline.lineStyle(1, 0x0066ff, 1)
		underline.beginPath()
		underline.moveTo(termsText.x, termsText.y + termsText.height / 2 + 2)
		underline.lineTo(
			termsText.x + termsText.width,
			termsText.y + termsText.height / 2 + 2,
		)
		underline.closePath()
		underline.strokePath()

		this.uiContainer.add([termsText, underline])

		// Make only the terms part interactive
		termsText.setInteractive()
		termsText.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.termsAndConditions(this.inputField)
		})

		this.termsCheckbox = this.add.rexCheckbox(
			this.safeZoneWidth / 2 - 150 * this.scaleFactor,
			loginBG.y + 30 * this.scaleFactor,
			25 * this.scaleFactor,
			25 * this.scaleFactor,
			{
				color: 0x5c58eb,
				checked: false,
				boxLineWidth: 2,
				animationDuration: 10,
				checkerSize: 0.8,
			},
		)
		this.uiContainer.add(this.termsCheckbox)

		// Agree button
		let agreeButton = this.add
			.image(
				this.safeZoneWidth / 2 + 70 * this.scaleFactor,
				this.safeZoneHeight / 2 + 110 * this.scaleFactor,
				"okBtn",
			)
			.setInteractive()
			.setScale(1 * this.scaleFactor)
		this.uiContainer.add(agreeButton)

		agreeButton.setAlpha(0.5) // Set initial alpha to 0.5
		agreeButton.input.enabled = false // Disable the button initially

		// // @DESC: Cancel button
		let cancelBtn = this.add
			.image(
				this.safeZoneWidth / 2 - 50 * this.scaleFactor,
				this.safeZoneHeight / 2 + 110 * this.scaleFactor,
				"saveBtn",
			)
			.setInteractive()
			.setScale(1 * this.scaleFactor)

		cancelBtn.setAlpha(1) // Set initial alpha to 0.5
		cancelBtn.input.enabled = true // Disable the button initially

		this.uiContainer.add(cancelBtn)

		cancelBtn.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.inputField.remove()
			this.cameras.main.fadeOut(500, 0, 0, 0)
			this.cameras.main.on("camerafadeoutcomplete", () => {
				this.scene.start("StartScene")
			})

		})

		agreeButton.on("pointerdown", () => {
			if (!this.inputString) {
				//return alert("Please enter your ID");
				return
			}
			if (this.inputString.length < 7) {
				console.log("input string length:" + this.inputString.length)
				return
			}
			if (!this.termsCheckbox.checked) {
				//return alert("Please accept terms");
				return
			}
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			this.inputField.remove()
			this.saveUserData(this.inputString)
				; (async () => {
					const GAME_KEY = process.env.GAME_ANALYTICS_GAME_KEY
					const SECRET_KEY = process.env.GAME_ANALYTICS_SECRET_KEY
					//await this.pushToApi(this.inputString);

					// const storedData = localStorage.getItem("userData")
					// 				const userData = storedData ? JSON.parse(storedData) : null
					// 				const userId = userData?.userID || "guest"
					// const isNewUser = load
					GameAnalytics.configureUserId(`${this.inputString}`)

					GameAnalytics.initialize(GAME_KEY, SECRET_KEY)

					if (!window._loginLogged) {
						const timestamp = Date.now()
						const readableDate = new Date(timestamp)
							.toISOString()
							.split("T")[0]
							.replace(/-/g, "")
						const isNewUser = !localStorage.getItem("hasPlayedBefore")

						// @DESC Track user type (new or returning)
						GameAnalytics.addDesignEvent(
							`user_login:${isNewUser ? "new" : "returning"}`,
						)

						// @DEC Track initial startup
						GameAnalytics.addDesignEvent(
							`game_startup:${this.inputString}:${timestamp}`,
						)
						GameAnalytics.addDesignEvent(`dau_tracking:${this.inputString}`)
						GameAnalytics.addDesignEvent(
							`session_start:${this.inputString}:${readableDate}`,
						)

						// @DESC Optional: Track level progression start if relevant here
						GameAnalytics.addProgressionEvent(
							"Start",
							`planet_${this.currentPlanet}`,
						)

						// Mark first time player
						if (isNewUser) {
							localStorage.setItem("hasPlayedBefore", "true")
						}

						window._loginLogged = true
					}

					this.handleLogin(this.inputString)
					this.cameras.main.fadeOut(500, 0, 0, 0)
				})()
		})

		let cancelText = this.add
			.text(cancelBtn.x, cancelBtn.y - 8 * this.scaleFactor, "CANCEL", {
				fontSize: Math.round(this.fontSize + 2 * this.scaleFactor),
				fill: "#fff",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)

		this.uiContainer.add(cancelText)

		let agreeText = this.add
			.text(agreeButton.x, agreeButton.y - 8 * this.scaleFactor, "OK", {
				fontSize: Math.round(this.fontSize + 2 * this.scaleFactor),
				fill: "#fff",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)
			.setAlpha(0.5) // Set initial alpha to 0.5
		this.uiContainer.add(agreeText)

		this.tweens.add({
			targets: this.black,
			alpha: 0,
			duration: 500,
			ease: "Power2",
		})
	}

	termsAndConditions(inputField) {
		inputField.style.visibility = "hidden"

		// Create a container for UI elements
		this.termsContainer = this.add.container(this.safeZoneX, this.safeZoneY)
		this.termsContainer.setDepth(10)

		// Add the login container background
		let loginBG = this.add
			.image(
				this.safeZoneWidth / 2 + 10 * this.scaleFactor,
				this.safeZoneHeight / 2 + 20 * this.scaleFactor,
				"wideContainer",
			)
			.setScale(this.scaleFactor * 1.13, this.scaleFactor * 1.4)
		this.termsContainer.add(loginBG)

		// Add text elements, scaling font size based on scale factor
		let termsTitle = this.add
			.text(
				loginBG.x - 70 * this.scaleFactor,
				loginBG.y - 120 * this.scaleFactor,
				"Galactic Terms & Conditions",
				{
					fontSize: Math.round(this.fontSize + 8 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "500",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
		this.termsContainer.add(termsTitle)

		let termsText = this.add
			.text(
				loginBG.x - 290 * this.scaleFactor,
				loginBG.y - 80 * this.scaleFactor,
				//"By playing this game, you consent to the use of your personal information by Mediclinic for\nanalytics, reporting, and research purposes, to help us improve the game, better understand\nour players, and assess digital skill levels.\n\n",
				"By playing this educational game, you consent to the use of your personal information by\nMediclinic for capturing, processing and storing, as well as analytics, reporting and research\npurposes. Your information will be managed in accordance with the Protection of Personal\nInformation Act (POPIA) and data will be stored in South Africa and the USA. This will help us to\nimprove the game and better understand our players and their digital literacy skills levels.",
				{
					fontSize: Math.round(this.fontSize - 7 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "600",
					// fontStyle: "bold",
					resolution: 1,
					wordWrap: {
						width: this.gameW * 0.78,
					},
				},
			)
			.setOrigin(0)

		this.termsContainer.add(termsText)
		let noteBetter = this.add
			.text(
				loginBG.x - 100 * this.scaleFactor,
				loginBG.y + 15 * this.scaleFactor,
				"You also agree to enjoy the game and have fun while playing!",
				{
					fontSize: Math.round(this.fontSize - 7 * this.scaleFactor) + "px",
					fill: "#11044E",
					fontFamily: '"Space Grotesk", sans-serif',
					fontWeight: "600",
					fontStyle: "bold",
					resolution: 2,
					wordWrap: {
						width: this.gameW * 0.6,
					},
				},
			)
			.setOrigin(0.5)
		this.termsContainer.add(noteBetter)

		// Agree button
		let agreeButton = this.add
			.image(
				this.safeZoneWidth / 3 - 90 * this.scaleFactor,
				this.safeZoneHeight / 2 + 95 * this.scaleFactor,
				"saveBtn",
			)
			.setInteractive()
			.setScale(1 * this.scaleFactor)
		this.termsContainer.add(agreeButton)

		agreeButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			deleteTerms()
		})

		let agreeText = this.add
			.text(agreeButton.x, agreeButton.y - 8 * this.scaleFactor, "ACCEPT!", {
				fontSize: Math.round(this.fontSize - 3 * this.scaleFactor),
				fill: "#fff",
				fontFamily: '"Gluten", sans-serif',
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			})
			.setOrigin(0.5)
		this.termsContainer.add(agreeText)

		let absoluteAcceptButton = this.add
			.image(
				this.safeZoneWidth / 2 + 150 * this.scaleFactor,
				this.safeZoneHeight / 2 + 95 * this.scaleFactor,
				"wideBtn",
			)
			.setInteractive()
			.setScale(this.scaleFactor * 0.6, this.scaleFactor * 0.5)
		this.termsContainer.add(absoluteAcceptButton)

		absoluteAcceptButton.on("pointerdown", () => {
			playUISound(this, this.soundManager, "Subtle click 1", 0.25)
			//deleteTerms()
			this.scene.start("StartScene")
		})

		let absoluteAcceptText = this.add
			.text(
				absoluteAcceptButton.x,
				absoluteAcceptButton.y - 6 * this.scaleFactor,
				"DO NOT ACCEPT",
				{
					fontSize: Math.round(this.fontSize - 3 * this.scaleFactor),
					fill: "#fff",
					fontFamily: '"Gluten", sans-serif',
					fontWeight: "700",
					fontStyle: "bold",
					resolution: 2,
				},
			)
			.setOrigin(0.5)
		this.termsContainer.add(absoluteAcceptText)

		const deleteTerms = () => {
			this.termsCheckbox.checked = true
			this.termsContainer.destroy()
			inputField.style.visibility = "visible"
		}
	}

	saveUserData(userID) {
		// let userData = this.cache.json.get('userData');
		// userData.userID = userID;
		// this.cache.json.add('userData', userData);
		// this.cache.json.add('userData', userData);

		// console.log(userData);

		let savedUserData = checkLocalSavedData()
		savedUserData.userID = userID
		localStorage.setItem("userData", JSON.stringify(savedUserData))

		console.log(savedUserData)
	}

	// Updated login method in LoginScene.js
	async handleLogin(playerId) {
		try {
			console.log(
				`Attempting to fetch player ${playerId} from ${this.api.baseUrl}/players/${playerId}`,
			)
			console.log("Using headers:", this.api.getHeaders())

			// Get player progress when they login
			const progress = await this.api.getPlayerProgress(playerId)
			console.log("Player progress:", progress)

			if (progress.length === 0) {
				console.log("Player progress is empty")
				this.saveUserData(playerId)
				this.cameras.main.fadeOut(500, 0, 0, 0)
				this.scene.start("StoryIntroScene")
			} else {
				console.log("Player progress is not empty")

				// Extract customisation data
				const customisation = progress.data?.customisation
				console.log("Player customisation:", customisation)

				// Check for specific milestones
				const targetMilestones = ["C3.3.7", "C3.3.4", "C2.1.4"]
				const playerMilestones = progress.data?.milestones || []

				// Get milestone labels from the response
				const completedMilestones = playerMilestones.map(
					(milestone) => milestone.Label,
				)
				console.log("Completed milestones:", completedMilestones)

				// Check which target milestones exist
				const existingTargetMilestones = targetMilestones.filter((target) =>
					completedMilestones.includes(target),
				)

				console.log("Target milestones found:", existingTargetMilestones)
				console.log(
					"Missing target milestones:",
					targetMilestones.filter(
						(target) => !completedMilestones.includes(target),
					),
				)

				// Store customisation data if needed
				if (customisation) {
					// You can save this to your user data or use it as needed
					this.saveCustomisationData(customisation)
				}

				// Check for specific milestones and determine actions
				const hasC337 = completedMilestones.includes("C3.3.7")
				const hasC334 = completedMilestones.includes("C3.3.4")
				const hasC214 = completedMilestones.includes("C2.1.4")

				console.log(`C3.3.7 completed: ${hasC337}`)
				console.log(`C3.3.4 completed: ${hasC334}`)
				console.log(`C2.1.4 completed: ${hasC214}`)

				let userData

				if (hasC214) {
					console.log("Player has started Planet 3")
					let newJSON = {
						userID: playerId,
						userLevel: 0,
						userMiniLevel: 0,
						planetsUnlocked: 3,
						planetsCompleted: 2,
						currentPlanet: 3,
						customizationCompleted: "true",
						customization: {
							tribe: customisation?.tribe || 1,
							rocket: customisation?.rocket || 1,
							ornament: customisation?.ornament || 1,
						},
						creatureActive: 0,
						creaturesUnlocked: [1],
						creaturesDischarged: [1, 2, 3, 4, 5, 6, 7, 8],
						emailsOpened: 0,
						alertsOpened: {
							facialScan: false,
							securityCheck: false,
							restartDevice: false,
							reconnectDevice: false,
							robotAlert: false,
							otpAlert: false,
						},
						onboardingCompleted: true,
					}

					userData = newJSON

					console.log("Set All Data for Planet 3")

					localStorage.setItem("userData", JSON.stringify(userData))

					this.cameras.main.fadeOut(500, 0, 0, 0)
					this.scene.start("PlanetSelector")
				} else if (hasC334) {
					console.log("Player has started Planet 2")
					let newJSON = {
						userID: playerId,
						userLevel: 0,
						userMiniLevel: 0,
						planetsUnlocked: 2,
						planetsCompleted: 1,
						currentPlanet: 2,
						customizationCompleted: "true",
						customization: {
							tribe: customisation?.tribe || 1,
							rocket: customisation?.rocket || 1,
							ornament: customisation?.ornament || 1,
						},
						creatureActive: 0,
						creaturesUnlocked: [1],
						creaturesDischarged: [1, 2, 3, 4, 5],
						emailsOpened: 0,
						alertsOpened: {
							facialScan: false,
							securityCheck: false,
							restartDevice: false,
							reconnectDevice: false,
							robotAlert: false,
							otpAlert: false,
						},
						onboardingCompleted: true,
					}

					userData = newJSON

					console.log("Set All Data for Planet 2")

					localStorage.setItem("userData", JSON.stringify(userData))

					this.cameras.main.fadeOut(500, 0, 0, 0)
					this.scene.start("PlanetSelector")
				} else if (hasC337) {
					console.log("Player has started Planet 1")
					let newJSON = {
						userID: playerId,
						userLevel: 0,
						userMiniLevel: 0,
						planetsUnlocked: 1,
						planetsCompleted: 0,
						currentPlanet: 1,
						customizationCompleted: "true",
						customization: {
							tribe: customisation?.tribe || 1,
							rocket: customisation?.rocket || 1,
							ornament: customisation?.ornament || 1,
						},
						creatureActive: 0,
						creaturesUnlocked: [1],
						creaturesDischarged: [1, 2],
						emailsOpened: 0,
						alertsOpened: {
							facialScan: false,
							securityCheck: false,
							restartDevice: false,
							reconnectDevice: false,
							robotAlert: false,
							otpAlert: false,
						},
						onboardingCompleted: true,
					}

					userData = newJSON

					console.log("Set All Data for Planet 1")

					localStorage.setItem("userData", JSON.stringify(userData))

					this.cameras.main.fadeOut(500, 0, 0, 0)
					this.scene.start("PlanetSelector")
				} else {
					console.log("Player is on Planet 1")
					let newJSON = {
						userID: playerId,
						userLevel: 0,
						userMiniLevel: 0,
						planetsUnlocked: 1,
						planetsCompleted: 0,
						currentPlanet: 1,
						customizationCompleted: "true",
						customization: {
							tribe: customisation?.tribe || 1,
							rocket: customisation?.rocket || 1,
							ornament: customisation?.ornament || 1,
						},
						creatureActive: 0,
						creaturesUnlocked: [1],
						creaturesDischarged: [1, 2],
						emailsOpened: 0,
						alertsOpened: {
							facialScan: false,
							securityCheck: false,
							restartDevice: false,
							reconnectDevice: false,
							robotAlert: false,
							otpAlert: false,
						},
						onboardingCompleted: false,
					}

					userData = newJSON

					console.log("Set All Data for Planet 1")

					localStorage.setItem("userData", JSON.stringify(userData))

					this.cameras.main.fadeOut(500, 0, 0, 0)
					this.scene.start("PlanetSelector")
				}
			}

			// Rest of your code...
		} catch (error) {
			console.error("Login error details:", error)
			if (error.response && error.response.status === 404) {
				console.log(`Player ${playerId} does not exist.`)
			}
			// Show error message to player
			this.cameras.main.fadeOut(500, 0, 0, 0)
			this.scene.start("StoryIntroScene")
		}
	}

	// Helper method to save customisation data
	saveCustomisationData(customisation) {
		const userData = {
			tribe: customisation.tribe,
			rocket: customisation.rocket,
			ornament: customisation.ornament,
		}

		let savedUserData = checkLocalSavedData()
		savedUserData.customization.tribe = userData.tribe
		savedUserData.customization.rocket = userData.rocket
		savedUserData.customization.ornament = userData.ornament
		savedUserData.customizationCompleted = true

		localStorage.setItem("userData", JSON.stringify(savedUserData))
		console.log("Saving customisation data:", userData)
	}

	unlockCompletedLevels(completedMilestones) {
		// Example function to update your game state based on completed milestones
		if (completedMilestones.includes("milestone_01_intro")) {
			// Unlock level 1
			console.log("Level 1 unlocked")
		}

		if (completedMilestones.includes("milestone_02_basics")) {
			// Unlock level 2
			console.log("Level 2 unlocked")
		}

		// etc.
	}

	async completeLevel(milestoneId) {
		try {
			// Record that the player completed this milestone
			await this.api.recordMilestoneCompletion(this.playerId, milestoneId)
			console.log(`Milestone ${milestoneId} recorded as completed`)

			// Update game state
			// Show congratulations message, etc.
		} catch (error) {
			console.error("Error recording milestone completion:", error)
			// Handle error
		}
	}

	async submitRating(rating, feedback = "") {
		try {
			// Record player's rating and feedback
			await this.api.recordRating(this.playerId, rating, feedback)
			console.log("Rating submitted successfully")

			// Thank the player
		} catch (error) {
			console.error("Error submitting rating:", error)
			// Handle error
		}
	}

	// Example: Call this when Level 1 is completed
	completeLevel1() {
		this.completeLevel("milestone_01_intro")
	}

	// For admin purposes only - get all player data
	async getAdminData() {
		try {
			const allPlayerData = await this.api.getAllPlayerProgress({
				page: 1,
				pageSize: 50,
				sort: "createdAt:desc",
			})

			console.log("All player data:", allPlayerData)
		} catch (error) {
			console.error("Error fetching admin data:", error)
		}
	}
}
